import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Constants } from '@hub/common/Constants';
import { eActionState, eGridType } from '@hub/generated/enums';
import { GridOptionDto, GridV2Dto, ServerPagingResult } from '@hub/generated/models';
import { GridController } from '@hub/generated/services';
import { GridMessages } from '@hub/generated/_messages';
import { NotificationService } from '@hub/services/NotificationService';

@Component({
  selector: 'main-grid-dialog',
  templateUrl: './main-grid-dialog.component.html'
})
export class MainGridDialogComponent implements OnInit {
  constructor(
    public gridController: GridController,
    public notificationService: NotificationService
  ) { }

  setting: GridV2Dto;
  isVisible: boolean = true;
  isCreate: boolean;
  emptyRows = new ServerPagingResult();

  @Output() onSave: EventEmitter<GridOptionDto> = new EventEmitter<GridOptionDto>();
  @Output() onClose: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() GridDto: GridV2Dto;

  ngOnInit() {
    this.emptyRows.Data = [{}, {}, {}];

    this.setting = this.GridDto;
    this.isCreate = this.setting.Option.GridType === eGridType.SytemDefault;
  }

  Save() {
    if (this.isCreate) {
      this.setting.Id = Constants.GUID_EMPTY;
      this.setting.ActionState = eActionState.Inserted;
      this.gridController.AddNewGridV2(this.setting)
        .subscribe(data => {
          this.onSave.emit(data.Option);
          this.notificationService.success(GridMessages.GridAddedSuccess);
        });
    } else {
      this.setting.ActionState = eActionState.Changed;
      this.gridController.UpdateGridV2(this.setting)
        .subscribe(data => {
          this.onSave.emit(data.Option);
          this.notificationService.success(GridMessages.GridEditSuccess);
        });
    }
  }

  Close() {
    this.onClose.emit(false);
  }

  onChange(event: GridV2Dto) {
    this.GridDto.Columns = event.Columns.filter(i => i != undefined);
    this.setting = event;
  }
}
